import { render, staticRenderFns } from "./SchoolName.vue?vue&type=template&id=159cea25&scoped=true&"
import script from "./SchoolName.vue?vue&type=script&lang=js&"
export * from "./SchoolName.vue?vue&type=script&lang=js&"
import style0 from "./SchoolName.vue?vue&type=style&index=0&id=159cea25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cea25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159cea25')) {
      api.createRecord('159cea25', component.options)
    } else {
      api.reload('159cea25', component.options)
    }
    module.hot.accept("./SchoolName.vue?vue&type=template&id=159cea25&scoped=true&", function () {
      api.rerender('159cea25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/SchoolName.vue"
export default component.exports